import { useEffect, useState } from "react"
import { getAllNotifications } from "../../../../utils/apis/user-service"
import { useAuth } from "../../../../utils/context/AuthContext"
import { Notification } from "../types/Notification"

export const useGetNotifications = () => {
    const { auth } = useAuth()
    const idToken = auth.idToken
    const [notifications, setNotifications] = useState<Notification[]>([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (!idToken) return

        const fetchNotifications = async () => {
            try {
                const data: Notification[] = await getAllNotifications(idToken)
                setNotifications(data)
            } finally {
                setIsLoading(false)
            }
        }

        fetchNotifications()
    }, [idToken])

    return { notifications, isLoading }
}